import {
  CoreTokens,
  inject,
  injectable,
  type LiveWorkflowRepository,
  type WorkflowDefinition,
  type WorkflowId,
} from "@codemation/core";

import type { TestRunnerWorkflowLookup } from "./TestRunnerService";

@injectable()
export class TestRunnerWorkflowLookupAdapter implements TestRunnerWorkflowLookup {
  constructor(@inject(CoreTokens.LiveWorkflowRepository) private readonly liveWorkflows: LiveWorkflowRepository) {}

  resolveWorkflow(workflowId: WorkflowId): WorkflowDefinition | undefined {
    return this.liveWorkflows.get(workflowId);
  }
}
